import { Button } from '@mui/material'
import * as Styled from './EditPollPage.styles'
import { FormBuilder, PageContainer, PollQuestionInput } from '../../components'
import { useForm } from 'react-hook-form'
import { DeleteSweepOutlined as DeleteSweepOutlinedIcon } from '@mui/icons-material'
import { useLocation, useNavigate } from 'react-router-dom'
import { Poll } from '../../modals/CreatedPollModal/PollDataModel'
import { useEffect, useState } from 'react'
import { editPollForEvent } from '../../services/appsync'
import LoadingModal from '../../modals/LoadingModal/LoadingModal'

const EditPollPage = () => {
  const location = useLocation()
  const data = location.state
  const passedPoll = data.pollObj as Poll
  const parsedResponses = passedPoll.responses.map((response: string) =>
    JSON.parse(response)
  )

  const navigate = useNavigate()

  let convertedResponses: { id: string; answer: string }[] = []
  const [fieldsCompleted, setFieldsCompleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState('')

  convertedResponses = parsedResponses.map(
    (response: { [key: string]: string }) => {
      const key = Object.keys(response)[0]
      return { id: key, answer: response[key] }
    }
  )

  const formMethods = useForm({
    defaultValues: {
      pollQuestion: { question: passedPoll.question },
      pollAnswers: convertedResponses,
    },
    mode: 'onChange',
  })

  const formValues = formMethods.watch()
  useEffect(() => {
    var questionCompleted = !(
      formMethods.getValues('pollQuestion.question').trim().length === 0
    )
    var answersCompleted = !(
      formMethods.getValues('pollAnswers').length !== 0 &&
      formMethods
        .getValues('pollAnswers')
        .some((answer: any) => answer.answer.trim().length === 0)
    )
    setFieldsCompleted(questionCompleted && answersCompleted)
  }, [formValues, formMethods])

  const editPollForThisEvent = async (targetPoll: Poll) => {
    try {
      setLoading(true)
      setLoadingMessage('Updating poll...')

      let responsesObj: string[] = []

      responsesObj = formMethods
        .getValues('pollAnswers')
        .filter((item) => item.answer.trim().length !== 0)
        .map((item) => JSON.stringify({ [item.id]: item.answer }))

      await editPollForEvent(
        targetPoll.eventId,
        targetPoll.pollId,
        formMethods.getValues('pollQuestion.question'),
        responsesObj
      )

      navigate(-1)
    } catch (error) {
      console.error('Error updating poll: ', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingModal
        open={loading}
        onClose={() => setLoading(false)}
        message={loadingMessage}
      />
      <PageContainer>
        <Styled.PaddedContainer>
          <Styled.PageTitle display="flex">Edit Poll</Styled.PageTitle>
          <Styled.PollContainer>
            <Styled.PollInstructions>
              Fill out the details of the poll, then save. When you’re ready to
              push this poll to attendees, you can do so from the Live Event
              page or from the Manage Events page under the Upcoming tab.
            </Styled.PollInstructions>
            <Styled.PollInstructionsSubtitle>
              Polls can only contain one multiple choice quesiton, where only
              one answer can be selected by attendees answering.
            </Styled.PollInstructionsSubtitle>
            <PollQuestionInput control={formMethods.control} />
            <FormBuilder
              control={formMethods.control}
              formName="pollAnswers"
              isPollPage={true}
              placeholder="Enter answer option..."
            />
          </Styled.PollContainer>
        </Styled.PaddedContainer>
        <Styled.ButtonContainer>
          <Styled.ButtonInnerContainer>
            <Button
              variant="text"
              startIcon={<DeleteSweepOutlinedIcon />}
              onClick={() => {
                console.log('Clear poll functionality not implemented yet')
              }}
            >
              Clear
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                editPollForThisEvent(passedPoll)
              }}
              disabled={!fieldsCompleted}
            >
              Save Poll
            </Button>
          </Styled.ButtonInnerContainer>
        </Styled.ButtonContainer>
      </PageContainer>
    </>
  )
}

export default EditPollPage
